import { translateFn } from '../../../../../../../../utils/translator.helper';
import { FormValidator, ValidationResult } from '../../../../../../../../ui/gzForm/formField/types/form-validator';
import { AntimalwareSecurityServersSvaIp } from '@nirvana/shared/dtos/types/policies/common';
import { MaxLengthValidator } from '../../../../../../../../ui/gzForm/validators/max-length.validator';
import { MAX_ANTIMALWARE_SECURITY_SERVERS_CUSTOM_HOSTNAME_LENGTH } from '../../../../../utils/uiSettings/antimalware/antimalware.values';

// get validators for custom hostname field
export const customHostnameValidators = (): FormValidator<string>[] => {
  return [
    MaxLengthValidator(
      MAX_ANTIMALWARE_SECURITY_SERVERS_CUSTOM_HOSTNAME_LENGTH,
      translateFn('The custom server name/IP must not exceed {maxLength} characters.', {
        maxLength: MAX_ANTIMALWARE_SECURITY_SERVERS_CUSTOM_HOSTNAME_LENGTH,
      })
    ),
  ];
};

// validate duplicates
export function validateDuplicates(
  ruleItem: AntimalwareSecurityServersSvaIp,
  rulesInGrid: AntimalwareSecurityServersSvaIp[]
): ValidationResult {
  const hasDuplicates = rulesInGrid.some(
    (ruleInGrid: AntimalwareSecurityServersSvaIp) => ruleInGrid.endpointId === ruleItem.endpointId
  );

  if (hasDuplicates) {
    return {
      valid: false,
      error: translateFn('The entry already exists.'),
    };
  }

  return {
    valid: true,
  };
}
